import { Button } from "@/components/ui/button";
import { SUGGESTIONS_BY_MODULE } from "@/features/assistant/constants";
import { useClientModules } from "@/hooks/useClientModules";

interface Props {
  onPick: (text: string) => void;
  disabled?: boolean;
}

export function Suggestions({ onPick, disabled = false }: Props) {
  const { data: modules } = useClientModules();
  const available = new Set((modules ?? []).map((m) => m.module));
  const items = SUGGESTIONS_BY_MODULE.filter(
    (s) => s.module === null || available.has(s.module),
  ).slice(0, 3);

  return (
    <div
      className="space-y-2 py-6 text-center"
      data-testid="assistant-suggestions"
    >
      <p className="text-sm text-muted-foreground">
        Pergunte sobre a sua frota. Por exemplo:
      </p>
      <div className="flex flex-col items-center gap-2">
        {items.map((s, i) => (
          <Button
            key={s.text}
            variant="outline"
            size="sm"
            className="h-auto whitespace-normal"
            disabled={disabled}
            onClick={() => onPick(s.text)}
            data-testid={`assistant-suggestion-${i}`}
          >
            {s.text}
          </Button>
        ))}
      </div>
    </div>
  );
}
